/**
 * Event Handling Object
 */
var plekevent = {

    existing_event: null,
    countdown_timer: {},
    max_characters_sm_post: 1600,

    construct() {
        jQuery(document).ready(function () {
            plekevent.add_events_listener();
            plekevent.event_countdown();      
        });
    },

    add_events_listener() {
        jQuery("#event_start_date").on("change", function () {
            window.plekevent.check_existing_event();
        });
        jQuery("#event_end_date").on("change", function () {
            window.plekevent.check_date_difference();
            window.plekevent.check_existing_event();
        });
        jQuery("#youtube_add_shortcode").on("click", function (e) {
            e.preventDefault();
            window.plekevent.add_yt_video(e);
        });
        jQuery("#insert_galleries_shortcode").on("click", function (e) {
            e.preventDefault();
            window.plekevent.get_insert_gallery_overlay(e);
        });

        /* Change the progress bar */
        jQuery('.plek-add-event #add_event_basic input').on('change', function (e) {
            e.preventDefault();
            window.plekevent.changeAddEventProgressBar('basic');
        });
        jQuery('.plek-add-event #add_event_details input').on('change', function (e) {
            e.preventDefault();
            window.plekevent.changeAddEventProgressBar('details');
        });

        jQuery('#main').on('click', '.spellchecker_apply', (e) => {
            e.preventDefault();
            this.spellchecker_apply_text(e.currentTarget);
        });
        jQuery('#main').on('click', '.spellchecker_cancel', (e) => {
            e.preventDefault();
            this.spellchecker_cancel_text(e.currentTarget);
        });
        jQuery('body').on('click', '#do_insert_gallery', (e) => {
            e.preventDefault();
            this.do_insert_gallery();
        });
        jQuery('body').on('click', '#cancel_insert_gallery', (e) => {
            e.preventDefault();
            plektemplate.remove_overlay('response_overlay');
        });

        /** Social Media Review publisher */
        jQuery('body').on('click', '#sm-publisher-live-preview-refresh', (e) => {
            e.preventDefault();
            this.smPublisherRefreshPreview();
        });
        jQuery('body').on('click', '#post_review_to_sm', (e) => {
            e.preventDefault();
            this.smPostReviewToSocialMedia(e.currentTarget);
        });
        jQuery('body').on('change', '.event-mention-input', (e) => {
            this.smPublisherUpdateCharacterCount();
            this.updateItemsInstagram(e.currentTarget);
        });
        jQuery('body').on('change', '#event_text_sm', (e) => {
            this.smPublisherUpdateCharacterCount();
        });
        jQuery('body').on('click', '.event-mention-item .toggle-include', (e) => {
            e.preventDefault();
            this.smPublisherToggleInclude(e.currentTarget);
            this.smPublisherUpdateCharacterCount();
        });
        jQuery('body').on('click', '.event-mention-item .toggle-collaborator', (e) => {
            e.preventDefault();
            this.smPublisherToggleCollaboration(e.currentTarget);
            this.smPublisherUpdateCharacterCount();
        });
        jQuery('body').on('click', '.instagram-handle-con.handle-proposal button', (e) => {
            e.preventDefault();
            this.smPublisherProposalAction(e.currentTarget);
        });
        setTimeout(() => {
            if (empty(document.getElementById('event_sm_publisher_form'))) {
                return; //Ignore this timeout if it is the wrong screen
            }
            window.plekevent.smPublisherUpdateCharacterCount(); //Do the first count
            window.plekevent.smPublisherRefreshPreview(); //Refresh the preview

            //check for missing inst mentions
            window.plekevent.smPublisherCheckMentions();

            if (typeof tinymce !== 'undefined') {
                const editor = tinymce.get('event_text_sm');
                if (editor) {
                    editor.on('change input keyup NodeChange', function () {
                        window.plekevent.smPublisherUpdateCharacterCount();
                    });
                }
            }
        }, 2000);
    },

    /**
     * Applies the spellchecked text to the corresponding text area or input field, and removes the spellchecker container from the DOM.
     * @param {Object} button - The apply button element that was clicked.
     */
    spellchecker_apply_text(button) {
        //Remove the spellchecker action popup
        jQuery('.plek-spellchecker-container .action-popup').remove();
        const spellcheck_container = jQuery(button).closest('.plek-spellchecker-container');
        const input = jQuery(spellcheck_container).data('spellchecker-input-id');
        let text = jQuery(spellcheck_container).find('.spellchecker_content').html();
        text = text.trim();
        text = text.replace(/<br>/g, "\n");
        //Replace all the spans from the diff checker
        text = text.replace(/<span id="change-([0-9]*)" class="spellchecker-removed">(.*?\n?)<\/span>/g, '');
        text = text.replace(/<span id="change-([0-9]*)" class="spellchecker-added">(.*?\n?)<\/span>/g, '$2');

        if (typeof tinymce.editors[input] !== "undefined") {
            const is_visual = ((tinymce.editors[input].targetElm).getAttribute('aria-hidden') === 'true');
            if (is_visual) {
                tinymce.editors[input].setContent(text);
            } else {
                (tinymce.editors[input].targetElm).value = text;

            }
        } else {
            jQuery('#' + input).val(text);
        }
        jQuery(button).closest('.plek-spellchecker-container').remove();
    },
    /**
     * Cancels the spellchecker and removes the container from the DOM.
     * @param {Object} button - The cancel button element that was clicked.
     */
    spellchecker_cancel_text(button) {
        jQuery(button).closest('.plek-spellchecker-container').remove();
    },
    /**
     * Checks if the page has a countdown and runs it
     */
    event_countdown() {
        jQuery(".plek-countdown").each((index, item) => {
            const deadline = jQuery(item).data("till-date-seconds");
            const target = jQuery(item).find(".countdown");
            plekevent.event_display_countdown(deadline, target);
        });
    },
    /**
     * Displays the countdown to the page
     * @param {int} deadline The timestamp with the deadline
     * @param {string} target The target to add the countdown to
     */
    event_display_countdown(deadline, target) {
        var now = new Date().getTime(); // Get the current time
        var seconds_till = Math.floor(deadline - (now / 1000)); // Calculate the time remaining in seconds
        // Check if the timer has expired
        if (seconds_till <= 0) {
            jQuery(target).text("00h : 00m : 00s");
        } else {
            let days = Math.floor(seconds_till / (60 * 60 * 24));
            let days_rest = seconds_till % (60 * 60 * 24);

            let hours = Math.floor(days_rest / (60 * 60));
            let hours_rest = days_rest % (60 * 60);

            let minutes = Math.floor(hours_rest / 60);
            let minutes_rest = hours_rest % 60;

            hours = (hours.toString().length === 1) ? "0" + hours : hours;
            minutes = (minutes.toString().length === 1) ? "0" + minutes : minutes;
            seconds = (minutes_rest.toString().length === 1) ? "0" + minutes_rest : minutes_rest;
            let time = new Array;
            time[0] = (days > 0) ? days + 'd' : '';
            time[1] = (hours > 0) ? hours + 'h' : '';
            time[2] = (minutes > 0) ? minutes + 'm' : '';
            if (seconds > 0 && days < 1) {
                time[3] = seconds + 's';
            }
            time = time.filter(Boolean);
            time = time.join(" : ");
            //set the time
            jQuery(target).text(time);

            setTimeout(function () {
                plekevent.event_display_countdown(deadline, target);
            }, 1000); // Run it again after 1 second
        }
    },
    /**
     * Checks if there is a event at the same date with the same bands.
     * @returns bool true if event exists, otherwise false
     * @todo: Replace with send form
     */
    check_existing_event() {
        if (this.is_edit_event()) {
            return null; //Is edit event, disable this function
        }
        if (this.get_field_value('event_start_date') !== "" && jQuery('#event-band-selection .item').length > 0) {
            //ajax call for checking
            var datab = new FormData();
            datab.append('action', 'plek_ajax_event_form');
            datab.append('type', 'check_event_duplicate');
            datab.append('event_start_date', this.get_field_value('event_start_date'));
            datab.append('event_end_date', this.get_field_value('event_end_date'));
            datab.append('event_band', this.get_field_value('event_band'));

            plek_main.send_form(datab, false, '', () => { console.log('Cool, Event does not exist'); });
            return;
        }
        return null;
    },

    /**
     * Checks if the start and end date are further apart that 3 days.
     * Displays toastr error
     */
    check_date_difference() {
        //Check if the date is valid
        const start_date = new Date(this.get_field_value('event_start_date'));
        const end_date = new Date(this.get_field_value('event_end_date'));
        if (!isNaN(end_date)) {
            const event_duration_days = (end_date.getTime() - start_date.getTime()) / 1000 / 60 / 60 / 24; //Difference in days
            if ((event_duration_days) > 4) {
                const date_error = __('Event duration is too long. Sure it is %s days?', 'plekvetica').replace("%s", Math.round(event_duration_days));
                window.plekerror.display_info(__('Date checker', 'plekvetica'), date_error);
            }
        }
    },

    /**
     * Adds a new saved band to the selection and updates the preloader object
     * 
     * @param {string}  id The type 
     * @param {int}  id The band_id 
     * @param {object}  data The band preloadDataobject 
     */
    add_new_vob_to_selection(type, vob_id, data) {
        if (typeof data === 'string' && plek_main.is_valid_JSON(data)) {
            //Make sure that the data is an object
            data = JSON.parse(data);
            if (typeof data !== 'object') {
                console.error("Data must be object - add_new_vob_to_selection");
                return false;
            }
        }

        switch (type) {
            case 'band-form-submit':
                window.bandPreloadedData = data;
                let band = window.bandPreloadedData[vob_id];
                let ele_b = plektemplate.load_band_item_template(band);
                this.add_item_to_selection(ele_b, 'event-band-selection');
                plekerror.display_info(__('Add Band', 'plekvetica'), __('The Band has been added to the Database', 'plekvetica'));
                break;
            case 'venue-form-submit':
                window.venuePreloadedData = data;
                let venue = window.venuePreloadedData[vob_id];
                let ele_v = plektemplate.load_venue_item_template(venue);
                this.add_item_to_selection(ele_v, 'event-venue-selection');
                plekerror.display_info(__('Add Venue', 'plekvetica'), __('The Venue has been added to the Database', 'plekvetica'));
                break;
            case 'organizer-form-submit':
                window.organizerPreloadedData = data;
                let organizer = window.organizerPreloadedData[vob_id];
                let ele_o = plektemplate.load_organizer_item_template(organizer);
                this.add_item_to_selection(ele_o, 'event-organizer-selection');
                plekerror.display_info(__('Add Organizer', 'plekvetica'), __('The Organizer has been added to the Database', 'plekvetica'));
                break;
            default:
                return false;
                break;
        }
        return true;
    },

    /**
     * 
     * @param {string} element DOM Element from plektemplate.load_XXX_item_template(); 
     * @param {string} item the item data as an object 
     * @todo Sort by playtime
     */
    add_item_to_selection(element, item_for) {
        //var item_for = jQuery(element).data('for');
        var type = jQuery(element).data('type');
        var item_id = jQuery(element).data('id');
        var html = jQuery(element).html();
        const vob_timestamp = jQuery(element).data('timestamp');
        const vob_sort = jQuery(element).data('sort');
        var data = { id: item_id, html: html, timestamp: vob_timestamp, sort: vob_sort }
        var data_to_insert = plektemplate.get_item_to_add(data);
        //Remove Existing Venues
        if (type === 'event_venue') {
            this.remove_all_items('event-venue-selection');
        }
        //Only add if not already added
        if (jQuery(`#${item_for} .plek-select-item[data-id='${item_id}']`).length === 0) {
            const elements = document.querySelectorAll('#' + item_for + ' .item');
            if (elements.length === 0) {
                //first element
                jQuery('#' + item_for).append(data_to_insert);
            } else if (vob_sort !== 'undefined' && vob_sort !== undefined) {
                for (let i = 0; i < elements.length; i++) {
                    const added_sort = elements[i].dataset.sort;
                    const added_next_sort = (typeof elements[i + 1] !== 'undefined') ? elements[i + 1].dataset.sort : null;
                    if (vob_sort < added_sort) {
                        //Add before the first element
                        jQuery('#' + item_for + ' .item[data-id="' + elements[i].dataset.id + '"]').before(data_to_insert);
                        break;
                    }
                    if (vob_sort >= added_sort && (vob_sort < added_next_sort || added_next_sort === null)) {
                        //Add after current element
                        jQuery('#' + item_for + ' .item[data-id="' + elements[i].dataset.id + '"]').after(data_to_insert);
                        break; //Stops the loop
                    }
                };
            } else {
                //Item has no sorting info, just add it at the end
                jQuery('#' + item_for).append(data_to_insert);
            }
        }

        jQuery('#event-band-selection .item').each(function (index, element) {
            //console.log(vob_sort);
        });
        /*
            if (typeof vob_timestamp !== 'undefined' && vob_timestamp !== 0) {
                this.vob_insert_with_timestamp(item_id, item_for, data_to_insert, vob_timestamp);
                console.log("Add item with timestamp: " + item_for);
            } else if (typeof vob_sort !== 'undefined') {
                this.vob_insert_with_sort(item_id, item_for, data_to_insert, vob_sort);
            } else {
                //Add it at the end
                console.log("Add item without timestamp or sort: " + item_for);
            }
        } else {
            console.log(item_id + ' already added (VOB)');
        }*/

        plektemplate.hide_overlay();
        jQuery('#' + type).val("");
        plekevent.add_remove_item_eventlistener();

        if (type === 'event_band') {
            if (!this.is_edit_event()) {
                window.plekevent.check_existing_event();
                window.plekevent.generate_title();
            }
            this.set_band_time_flatpickr(item_id);
        }

        /** Update the progressbar */
        window.plekevent.changeAddEventProgressBar('basic');
    },

    /**
     * Insert a plek-select-item according to the existing items timestamps.
     * @param {*} item_for 
     * @param {*} data_to_insert 
     * @param {*} vob_timestamp 
     */
    vob_insert_with_timestamp(item_id, item_for, data_to_insert, vob_timestamp) {
        //Search for items
        if (jQuery('#' + item_for + ' .plek-select-item').length === 0) {
            //no items added so far. Add it.
            jQuery('#' + item_for).append(data_to_insert);
            return;
        } else {
            //check for position to add
            jQuery('#' + item_for + ' .plek-select-item').each(function (i, e) {
                let ts = jQuery(e).data('timestamp');
                if (ts > vob_timestamp) {
                    //Item found thats bigger, add before
                    console.log("insert: " + item_for + ' on index' + i);
                    jQuery(data_to_insert).insertBefore(e);
                    return false; //break the loop
                }
            });
        }
        //If insert by timestamp failed, insert it at the end
        if (jQuery(`.plek-select-item[data-id='${item_id}']`).length === 0) {
            jQuery('#' + item_for).append(data_to_insert);
        }
        return;
    },

    vob_insert_with_sort(item_id, item_for, data_to_insert, vob_sort) {
        if (jQuery('#' + item_for + ' .plek-select-item').length === 0) {
            //no items added so far. Add.
            jQuery('#' + item_for).append(data_to_insert);
            return;
        } else {
            //check for position to add
            jQuery('#' + item_for + ' .plek-select-item').each(function (i, e) {
                let sort_index = jQuery(e).data('sort');
                if (sort_index > vob_sort) {
                    //Item found thats bigger, add before
                    jQuery(data_to_insert).insertBefore(e);
                    return;
                }
            });
        }
        //If insert by sort failed, insert it at the end
        if (jQuery(`.plek-select-item[data-id='${item_id}']`).length === 0) {
            jQuery('#' + item_for).append(data_to_insert);
        }
        return;
    },

    /**
     * Sets the flatpicker_band options and ensures that the date can only be set on the date of the event
     * @todo: allow individual item to be set? This function will update all band time inputs.
     * 
     * @param {int} item_id The ID of the Band
     * @returns 
     */
    set_band_time_flatpickr(item_id = null) {

        let last_item = jQuery('.band-time-input').last().val();
        this.set_flatpickr_band_time_options();

        //Set the flatpickr for all time inputs
        //This selects to many inputs, make more distinct selection!

        if (!empty(jQuery('#event-band-selection #band-time-' + item_id))) {
            plek_manage_event.flatpickr_band_options.defaultDate = plekevent.get_band_default_date(`#event-band-selection .plek-select-item[data-id='${item_id}']`);
            try {
                jQuery('#event-band-selection #band-time-' + item_id).flatpickr(plek_manage_event.flatpickr_band_options); //Load the Flatpickr
            } catch (error) {
                console.error("Flatpickr not loaded");
            }
            plekevent.update_band_playtime_button_text(`#event-band-selection .plek-select-item[data-id='${item_id}']`);
            return;
        }

        jQuery("#event-band-selection .band-time-input").each((index, item) => {
            if (empty(jQuery(item).attr('name'))) {
                return; //Skip if no name defined, aka it is a flatpickr input field 
            }
            if (jQuery(item).val() == 0) {
                return; //Skip if no value defined
            } else {
                //Update the timestamp, if time set.
                this.update_band_timestamp(item);
            }
            //Set the date from the input
            try {
                plek_manage_event.flatpickr_band_options.defaultDate = plekevent.get_band_default_date(jQuery(item).closest('.plek-select-item'));
                jQuery(item).flatpickr(plek_manage_event.flatpickr_band_options); //Load the Flatpickr
            } catch (error) {
                console.log(error);
            }
        });

        if (last_item === '0') {
            return; //End the function, if the last added item has no time set.
        }

        //Add the time to the label if set in the input
        jQuery('#event-band-selection .plek-select-item').each(function (index, item) {
            plekevent.update_band_playtime_button_text(item);

        });
        return;

    },

    /**
     * Updates the current timestamp of a band.
     * @param {object} item The Band item to get the time from (input band-time-xxx)
     * @returns void
     */
    update_band_timestamp(item) {
        let current_value = jQuery(item).val();
        if (current_value !== '00:00') {
            //Probably edit event, not timestamp loaded from the db
            let start_date = plekevent.get_event_date('event_start_date', 'date');
            if (current_value.length === 5) {
                //Is single day, add the date to the current value (current_value is only the time)
                const dateSplit = start_date.split('T');
                current_value = dateSplit[0] + ' ' + current_value;
            }
            let date = new Date(current_value);
            //Add the timezone offset to the time and convert to seconds.
            let timestamp_in_seconds = (date.getTime() - date.getTimezoneOffset() * 60000) / 1000;
            jQuery(item).closest('.plek-select-item').data('timestamp', timestamp_in_seconds);
        }
        return;
    },

    /**
     * Gets the default date of a band vob input
     * 
     * @param {object} item The Band item to get the time from (input band-time-xxx)
     * @returns The full date or the playtime.
     */
    get_band_default_date(item) {
        let timestamp = jQuery(item).data('timestamp');
        if (this.event_is_single_day()) {
            return (empty(timestamp)) ? '19:00' : plek_main.get_formated_date(timestamp, 'H:i');
        } else {
            return (empty(timestamp)) ? this.get_event_date('event_start_date', 'datetime') : plek_main.get_formated_date(timestamp, 'Y-m-d H:i:s');
        }
    },

    /**
     * Updates the time of the band playtime button
     * @param {object} item 
     */
    update_band_playtime_button_text(item) {
        let unix_timestamp = jQuery(item).data('timestamp');
        let js_date = new Date(unix_timestamp * 1000); //Convert to MS
        if (js_date.getFullYear() === 1970) {
            //Replace the button with the clock icon, if the date is not found
            jQuery(item).find('.time-label').html('<i class="far fa-clock"></i>');
            return false;
        }

        if (this.event_is_single_day()) {
            var time = plek_main.get_formated_date(unix_timestamp, 'H:i');
        } else {
            var time = plek_main.get_formated_date(unix_timestamp, 'd.m<br/>H:i');
        }
        //Update the button label
        jQuery(item).find('.time-label').html(time);
        return;
    },

    /**
     * Sets the flatpickr options depending on the event date.
     * @returns void
     */
    set_flatpickr_band_time_options() {
        //Set available dates
        let defaultStartDate = '2020-01-01';
        let defaultEndDate = '9020-01-01';
        //Set the Options for single day
        var is_single_day = this.event_is_single_day();
        if (is_single_day) {
            plek_manage_event.flatpickr_band_options.time_24hr = true;
            plek_manage_event.flatpickr_band_options.dateFormat = 'H:i';
            plek_manage_event.flatpickr_band_options.altFormat = 'H:i';
            plek_manage_event.flatpickr_band_options.noCalendar = true;
            plek_manage_event.flatpickr_band_options.enable = [{
                from: '00:00',
                to: '23:59'
            }];
        } else {
            //Event is multy day
            let startDate = this.get_event_date('event_start_date', 'date');
            let endDate = this.get_event_date('event_end_date', 'date');
            startDate = (startDate.length === 0) ? defaultStartDate : startDate;
            endDate = (endDate.length === 0) ? defaultEndDate : endDate;
            const startDateSplit = startDate.split('T');
            const endDateSplit = endDate.split('T');
            plek_manage_event.flatpickr_band_options.dateFormat = 'Y-m-d H:i:S';
            plek_manage_event.flatpickr_band_options.altFormat = 'j.m H:i';
            plek_manage_event.flatpickr_band_options.noCalendar = false;
            plek_manage_event.flatpickr_band_options.enable = [{
                from: startDateSplit[0] + ' 00:00:00',
                to: endDateSplit[0] + ' 23:59:59'
            }];
        }
        //console.log('Set flatpicker time. Singleday: ' + is_single_day);
        return;
    },

    /**
     * Removes the Item on .remove-item click
     */
    add_remove_item_eventlistener() {
        jQuery('.remove-item').click(function () {
            jQuery(this).closest('.plek-select-item').remove();
            if (!plekevent.is_edit_event()) {
                plekevent.generate_title(); //Regenerate the title
            }
        });
    },
    remove_all_items(selector) {
        jQuery('#' + selector + ' .item').remove();
    },

    /**
     * Checks if the edit_id field is set. If so, then it is edit event
     * @returns bool true if edit event, false otherwise
     * 
     */
    is_edit_event() {
        let id = this.get_field_value('event_id');
        return (typeof id !== 'undefined' && id.length > 0) ? true : false;
    },

    /**
     * Sends an ajax request to save the event.
     * 
     * @param {string} type Type of the form (only save_basic_event is supported atm.)
     * @param {string} form ID of the Form 
     * @returns 
     */
    async save_event(type, form) {
        var datab = this.prepare_data(type, form);

        //Disabled the JS validator, since it gets validated by the php validator
        /*if (plekvalidator.validate_form_data(datab, form) !== true) {
            jQuery('#' + form + ' .plek-main-submit-button').prop("disabled", false); //Enable the button again.
            plekvalidator.display_errors(form);
            return false;
        }*/

        //Check if event start date is valid
        if (plekevent.pre_save_event_check('startdate') === false) {
            return false;
        }
        let button = jQuery('#' + form + ' .plek-main-submit-button');
        //Validation was ok, send it to the server
        return await plek_main.send_form(datab, button, form, plekevent.on_save_event_success, false, false, { type: type });
    },

    /**
     * Called when the event has been saved successfully.
     * 
     * @param {object} response The response object from the server
     * @param {object} button The button that triggered this function
     * @param {object} atts Additional attributes
     * 
     * @returns void
     */
    on_save_event_success(response, button, atts) {
        //let text = plek_main.get_text_from_ajax_request(response, true);
        const event_id = plek_main.get_success_item_from_ajax_request(response, 'event_id');
        const user_id = plek_main.get_success_item_from_ajax_request(response, 'user_id');
        const event_url = plek_main.get_success_item_from_ajax_request(response, 'event_url');
        const type = atts.type;

        //It is a edit event. Do not redirect or change the url in anyway
        if (type === 'save_edit_event') {
            plek_main.form_success_callback(response)
            return;
        }

        //It is a Add Event process
        //Redirect to next stage and display the appropriate information
        plek_main.url_replace_param('event_id', event_id);
        var stage = 'details'; //Default is details
        if (type === 'save_basic_event' && user_id === 0) {
            //User is not logged in and type is basic event, set stage to login
            stage = 'login';
        }

        //Set the current stage
        let url = plek_main.url_replace_param('stage', stage);
        if (type === 'save_event_details') {
            if (user_id === 0 || user_id === false || event_url === false) {
                plekerror.display_info(__('Event saved!', 'plekvetica'), __('Thanks a lot!<br/>Our Eventmanager will check and publish the Event', 'plekvetica'));
            } else {
                //User is a logged in user
                let event_url_label = __('To my Event', 'plekvetica')
                let event_url_html = `<a href='${event_url}'>${event_url_label}</a>`;
                plekerror.display_info(__('Event saved!', 'plekvetica'), __('Check it out here: ' + event_url_html, 'plekvetica'));
            }
            plek_add_event_functions.remove_event_details_reminder(event_id);
        } else {
            //Show success message
            plekerror.display_info(__('Success', 'plekvetica'), __('Data saved! We redirect you shortly', 'plekvetica'));
            //Modifies the Button to direct to the next page
            jQuery(button).data('type', 'new_event_next_page');
            jQuery(button).data('url', url);
            jQuery(button).text(__('Add Event details', 'plekvetica'));

            //Auto redirect after 2 seconds
            setTimeout(() => {
                window.location = url;
            }, 2000);
        }
        if (type === 'save_basic_event') {
            const event_name = jQuery('input#event_name').val();
            plek_add_event_functions.add_event_details_reminder(event_id, event_name, 'login');
        }
        /** Set the indicator of the progress bar */
        if (type === 'save_event_details') {
            jQuery('#add-event-progress-bar .circle-publish').addClass('selected');
            jQuery('#add-event-progress-bar .line-details').addClass('full');
            jQuery('#add-event-progress-bar .circle-details').removeClass('selected');
        }
        return;

    },

    /**
     * Performs a pre-save check for the event based on the specified type.
     * 
     * @param {string} type - The type of check to perform. Currently supports 'startdate'.
     * @returns {boolean} - Returns true if the check passes or is not applicable. 
     *                      Returns the result of a confirmation dialog if the start date is today at 19:00:00.
     */

    pre_save_event_check(type) {
        switch (type) {
            case 'startdate':
                const today = new Date().toISOString().split('T')[0];
                if (this.is_edit_event() === false && this.get_field_value('event_start_date') === today + ' 19:00:00') {
                    return confirm(__('The startdate is today. Are you sure?', 'plekvetica'));
                }
                break;

            default:
                break;
        }
        return true;
    },

    /**
     * Saves the login for the event creation process and redirects to the event details page
     * @param {string} type - The type of the form (currently only 'save_event_login' is supported)
     * @param {string} [button='#plek-add-login-submit'] - The ID of the button to activate the loader style on
     * @param {string} [form='add_event_login'] - The ID of the form to validate
     * @returns {boolean} - Returns true if the request was sent successfully. 
     *                      Returns false if the validation fails or the event id is not set.
     */
    save_event_login(type, button = '#plek-add-login-submit', form = 'add_event_login') {
        console.log("savelogin " + type);
        const datab = this.prepare_data(type, form);
        plek_main.activate_loader_style(button);
        if (plekvalidator.validate_form_data(datab, form) !== true) {
            jQuery(button).prop("disabled", false); //Enable the button again.
            plek_main.deactivate_button_loader(button);
            plekvalidator.display_errors(form);
            return false;
        }
        return plek_main.send_form(datab, button, form, (response) => {
            const event_id = plek_main.get_success_item_from_ajax_request(response, 'event_id');

            //Update the reminder
            plek_add_event_functions.add_event_details_reminder(event_id, '', 'details');

            //Redirect to next stage
            plek_main.url_replace_param('event_id', event_id);
            let url = plek_main.url_replace_param('stage', 'details');
            window.location = url; //Redirect to the details page
            return;
        });
    },

    
    /**
     * Saves the event review by preparing the form data and sending it via AJAX.
     * @returns {void}
     */
    save_review() {
        const datab = plekevent.prepare_data('save_event_review', 'edit_event_review_form');
        const form = 'edit_event_review_form';
        const button = jQuery('#edit_event_review_form .plek-main-submit-button');
        plek_main.send_form(datab, button, form);
    },

    /**
     * Prepares the Form Data and Validator.
     * This functions adds the required fields to the validator for checking the values and adds the form data elements.
     * 
     * @param {string} type The type to prepare
     * @returns {object} FormData
     */
    prepare_data(type, form) {
        var datab = new FormData();
        datab.append('action', 'plek_ajax_event_form');
        datab.append('type', type);
        if (type === "save_basic_event" || type === 'save_edit_event') {
            //Fields for Event Basic
            datab.append('event_name', this.get_field_value('event_name'));
            datab.append('event_start_date', this.get_field_value('event_start_date'));
            if (jQuery('#is_multiday').is(':checked') === true) {
                plekvalidator.add_field('is_multiday', 'int', true, form);
                plekvalidator.add_field('event_end_date', 'date', true, form);
            } else {
                //Make sure to remove the end date if multiday is not selected
                jQuery('#event_end_date').val('');
            }

            datab.append('is_multiday', (jQuery('#is_multiday').is(':checked') === true) ? '1' : '0');
            datab.append('event_end_date', this.get_field_value('event_end_date'));

            if (jQuery('#no_band').is(':checked') === true) {
                datab.append('no_bands_known', "true");
                plekvalidator.add_field('event_band', 'int', true, form);
            } else {
                plekvalidator.add_field('event_band', 'int', false, form);
                plekvalidator.field_is_array('event_band', form);
            }
            datab.append('event_band', this.get_field_value('event_band'));
            datab.append('event_venue', this.get_field_value('event_venue'));
            datab.append('hp-password', this.get_field_value('hp-password'));

            let band_order_time = this.get_band_order_time();
            datab.append('band_order_time', band_order_time);
        }
        if (type === "save_event_details" || type === 'save_edit_event') {
            //Fields for Event Basic
            datab.append('event_description', this.get_field_value('event_description'));
            datab.append('event_organizer', this.get_field_value('event_organizer'));

            datab.append('event_poster', this.get_field_value('event_poster'));
            datab.append('event_fb_link', this.get_field_value('event_fb_link'));

            datab.append('event_price_boxoffice', this.get_field_value('event_price_boxoffice'));
            datab.append('event_currency', this.get_field_value('event_currency'));
            datab.append('event_price_presale', this.get_field_value('event_price_presale'));
            datab.append('event_price_link', this.get_field_value('event_price_link'));

            let event_id = this.get_field_value('event_id');
            datab.append('event_id', event_id);

        }
        //Guest login
        if (type === "save_add_event_login") {

            datab.append('guest_name', this.get_field_value('guest_name'));
            datab.append('guest_email', this.get_field_value('guest_email'));

            datab.append('event_id', this.get_event_id());
            datab.append('is_guest', true);
        }
        //User login
        if (type === "save_add_event_login_user") {
            datab.append('user_login', this.get_field_value('user_login'));
            datab.append('user_pass', this.get_field_value('user_pass'));
            datab.append('rememberme', this.get_field_value('rememberme'));

            datab.append('event_id', this.get_event_id());
            datab.append('is_guest', false);
        }
        if (type === 'save_edit_event') {
            datab.append('event_ticket_raffle_win_till', !empty(this.get_field_value('event_ticket_raffle_win_till')) ? this.get_field_value('event_ticket_raffle_win_till') : '');
            datab.append('event_ticket_raffle_conditions', !empty(this.get_field_value('event_ticket_raffle_conditions')) ? this.get_field_value('event_ticket_raffle_conditions') : '');
            plekvalidator.add_field('event_ticket_raffle_conditions', 'intplus', true, form);
            datab.append('event_status', this.get_field_value('event_status'));
            datab.append('event_featured', this.get_field_value('event_featured'));
            datab.append('event_promote', this.get_field_value('event_promote'));
            datab.append('is_postponed_check', this.get_field_value('is_postponed_check'));
            datab.append('event_team', this.get_field_value('event_team'));
            datab.append('event_festival', this.get_field_value('event_festival'));
            datab.append('event_partner', this.get_field_value('event_partner'));
        }

        if (type === 'save_event_review') {
            datab.append('event_id', this.get_field_value('event_id'));
            datab.append('event_text_lead', this.get_field_value('event_text_lead'));
            datab.append('publish_review', this.get_field_value('publish_review'));
            datab.append('mark_checked_review', this.get_field_value('mark_checked_review'));
            //Get all users and their role values
            jQuery('select.user_role_selector').each((i, e) => {
                datab.append(e.id, this.get_field_value(e.id));
            });
            if (!empty(this.get_field_value('review_old_album_id'))) {
                datab.append('event_review_old_album_id', this.get_field_value('review_old_album_id'));
            }
            datab.append('event_text_review', this.get_field_value('event_text_review'));
            datab.append('event_gallery_sortorder', JSON.stringify(plek_gallery_handler.get_band_gallery_sortorder()));
            datab.append('hp-password', this.get_field_value('hp-password'));
        }
        return datab;
    },

    /**
     * Loads the Event ID. If not found in a form field, it tries to load the ID from the local storage of the reminder function
     * @param add_to_form If the value should be added to the form.
     * @returns Event ID
     */
    get_event_id(add_to_form = true) {
        let event_id = this.get_field_value('event_id');
        if (empty(event_id)) {
            //Get the event_id from storage
            let prev_event = window.localStorage.getItem('plek_event_reminder');
            try {
                let prev_event_obj = JSON.parse(prev_event);
                event_id = (!empty(Object.keys(prev_event_obj)[0])) ? Object.keys(prev_event_obj)[0] : '';
                console.log("Event ID loaded from Storage");
            } catch (error) {
                console.log(error);
            }
        }
        if (add_to_form) {
            jQuery('input#event_id').val(event_id);
        }
        return parseInt(event_id);
    },

    /**
     * Gets the Order of the Band items
     * 
     * @returns {string} JSON String with the order Data: "{\"666\":{\"order\":1,\"datetime\":\"2022.02.03 13:30:00\"}}"
     * 
     */
    get_band_order_time() {
        let order_obj = {};
        let is_single_day_event = this.event_is_single_day();

        jQuery('#event-band-selection .plek-select-item').each((index, item) => {
            let band_id = jQuery(item).data('id');
            let datetime = jQuery(item).find('.band-time-input').first().val();
            //On Single day, band-time-input is only the time (H:i). Add the startdate as well
            if (is_single_day_event || datetime.length < 6) {
                //Add Date of single day of if datetime only contains the time
                let startDate = this.get_event_date('event_start_date', 'date');
                const dateSplit = startDate.split('T');
                datetime = dateSplit[0] + ' ' + datetime;
            }

            //If the time-label has not been replaced with the playtime, the datetime has to be set on 0 
            if (jQuery(item).find('.time-label').html().indexOf('clock') > 0) {
                datetime = 0;
            }

            order_obj[band_id] = { order: index, datetime: datetime };
        });

        return JSON.stringify(order_obj);
    },

    /**
     * Checks if the start- and enddates are matching, or if there is no enddate
     * @returns {bool} True if it is a single day event, false otherwise 
     */
    event_is_single_day() {

        //If the Multiday is not checked, it can only be a single day.
        if (jQuery('#is_multiday').is(':checked') === false) {
            return true;
        }
        let startDate = jQuery('#event_start_date').val();
        let startDateArr = startDate.split(' ');//Array [ "2022-01-20", "12:00:00" ] 

        let endDate = jQuery('#event_end_date').val();
        let endDateArr = endDate.split(' '); //Array [ "2022-01-20", "12:00:00" ] 
        if (endDate.length === 0) {
            return true;
        }

        if (startDateArr[0] === endDateArr[0]) {
            return true;
        }

        let startDD = new Date(startDate);
        let endDD = new Date(endDate);
        let nextDay = startDD.setTime(startDD.getTime() + (16 * 60 * 60 * 1000)); //Add 16h to the startdate
        if (new Date(nextDay) > endDD) { //Event is not longer than 16h, therefore it is a single day.
            return true;
        }
        return false;
    },

    /**
     * 
     * @param {string} id ID of the Input field to get the date from
     * @param {string} output Accepts both (Array date | time), date (String Y-m-d) & time (String H:i:s)
     * @returns {string} The formated date 
     */
    get_event_date(id = null, output = 'both') {
        let dateVal = jQuery('#' + id).val();
        if (typeof dateVal === 'undefined') {
            return '';
        }
        let dateSplit = dateVal.split(" ");
        switch (output) {
            case "date":
                return dateSplit[0];
                break;
            case "time":
                return (typeof dateSplit[1] !== 'undefined') ? dateSplit[1] : '';
                break;
            case "datetime":
                return jQuery('#' + id).val(); //Just returns the datetime as it is set in the input field
                break;
            default:
                return dateSplit;
                break;
        }
    },


    /**
     * Returns the value of an input field. This function takes into account the type of the input field.
     * If the input field is a checkbox, it returns the value of the checkbox if it is checked, otherwise it returns an empty string.
     * If the input field is a textarea, it returns the content of the textarea, otherwise it returns the value of the textarea.
     * If the input field is a file, it returns the file data of the input field.
     * If the input field is a date input field, it returns the date in the format Y-m-d H:i:s.
     * Otherwise, it returns the value of the input field.
     * 
     * @param {string} name The name of the input field to get the value from.
     * @returns {string} The value of the input field.
     */
    get_field_value(name) {
        let type = jQuery("#" + name).attr("type");
        if (typeof type === "undefined") {
            type = jQuery('#' + name).prop('type');
        }
        switch (type) {
            case 'checkbox':
                if (jQuery("#" + name + ":checked").length > 0) {
                    return jQuery('#' + name).val();
                } else {
                    return "";
                }
                break;
            case 'textarea':
                if (typeof tinymce.editors[name] !== "undefined") {
                    return tinymce.editors[name].getContent();
                }
                if (jQuery("#" + name + ":checked").length > 0) {
                    return jQuery('#' + name).val();
                } else {
                    return jQuery('#' + name).val();
                }
                break;

            case 'file':
                let file_data = jQuery('#' + name).prop('files')[0];
                return file_data;
                break;

            default:
                break;
        }

        switch (name) {
            case 'event_band':
                return this.get_selector_ids('event-band-selection');
                break;
            case 'event_venue':
                return this.get_selector_ids('event-venue-selection');
                break;
            case 'event_organizer':
                return this.get_selector_ids('event-organizer-selection');
                break;
            case 'event_start_date':
            case 'event_end_date':
            case 'event_ticket_raffle_win_till':
                const date_data = jQuery('#' + name).val();
                if (empty(date_data)) {
                    return date_data;
                }
                const date = new Date(date_data);
                return plek_main.get_formated_date(date.getTime() / 1000, "Y-m-d H:i:s", false);
                break;
            default:
                return jQuery('#' + name).val();
                break;
        }
    },

    /**
     * Gets all the ids from the plek-select-items in the given container
     * @param {string} selector_id The id of the container to get the ids from
     * @returns {array} An array of ids
     */
    get_selector_ids(selector_id) {
        var ids = [];
        var items = jQuery('#' + selector_id).find('.plek-select-item');
        jQuery.each(items, function (key, val) {
            var id = jQuery(val).data('id');
            ids.push(id);
        });
        if (Object.keys(ids).length === 0) {
            return "";
        }
        return ids;
    },

    /**
     * Creates the Events title based on the bandscore
     */
    generate_title() {
        let selected_bands = jQuery("#event-band-selection .item");
        var title_input = jQuery("#event_name");
        var band_order = [];
        jQuery.each(selected_bands, function (index) {
            let id = jQuery(this).data('id');
            let band_name = bandPreloadedData[id].name.replace('&amp;', '&');
            let band_score = parseInt(bandPreloadedData[id].score);
            band_order.push([band_score, band_name]);
        });
        band_order.sort(function (a, b) {
            var a0 = a[0];
            var b0 = b[0];
            if (a0 == b0) return 0;
            return a0 < b0 ? 1 : -1;
        });

        var total_items = band_order.length;
        var event_name_text = "";
        var max_items = 3;
        jQuery.each(band_order, function (index) {
            if (index === 0) {
                event_name_text = this[1]; //Name of the Band
                return;
            }
            if (max_items < index + 2) {
                //If the max items are reached. Add 2 to the index to get 3 items max
                event_name_text += " & " + this[1];
                return false;
            }
            if ((index + 1) !== total_items) { //Not last item
                event_name_text += ", " + this[1];
            } else { //Last item
                event_name_text += " & " + this[1];
            }
        });
        jQuery(title_input).val(event_name_text);
    },

    /**
     * Adds the shortcode to the event_description
     * @returns void
     */
    /**
     * Adds a YouTube video shortcode to the specified editor based on user input.
     * Prompts the user for a YouTube URL or video ID, validates it, and inserts the shortcode.
     * @param {Event} e - The event object from the click handler.
     */
    add_yt_video(e) {
        let linkInput = prompt(__('Enter URL or Youtube Video ID', 'plekvetica'));
        if (empty(linkInput)) {
            return;
        }
        const editor_id = (!empty(e.target.dataset.editorid)) ? e.target.dataset.editorid : '';
        const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
        const match = linkInput.match(regExp);
        const regExpID = /^[a-zA-Z0-9_-]{11}$/;
        const matchID = linkInput.match(regExpID);


        if (match && match[2].length == 11) {
            var id = match[2];
        } else if (matchID && matchID[0].length == 11) {
            var id = matchID[0];

        } else {
            window.plekerror.display_info(__('Notice', 'plekvetica'), __('Invalid URL or ID', 'plekvetica'));
            return;
        }
        //Add to description
        if (empty(editor_id)) {
            console.log('No Editor defined');
            return;
        }
        const shortcode = `[yotuwp type="videos" id="${id}" pagination="off" column="1" per_page="1"]`;
        plek_main.insert_text_wp_editor(editor_id, shortcode);

    },

    /**
     * Retrieves the overlay data for the insert review gallery button
     * @param {object} e - The event object
     * @returns void
     */
    get_insert_gallery_overlay(e) {
        const editor_id = (!empty(e.target.dataset.editorid)) ? e.target.dataset.editorid : '';
        var datab = new FormData();
        datab.append('action', 'plek_event_actions');
        datab.append('do', 'get_insert_review_gallery_data');
        datab.append('editor_id', editor_id);
        datab.append('event_id', this.get_field_value('event_id'));

        plek_main.send_form(datab, '#' + e.target.id, '', (response, button_id, attributes) => {
            plek_main.form_success_actions(response, attributes);
            const raw_data = plek_main.get_success_item_from_ajax_request(response, 'raw_data');
            if (!empty(raw_data) && raw_data !== false) {
                console.log('Raw data updated');
                try {
                    plek_gallery_handler.gallery_info = JSON.parse(raw_data);
                } catch (error) {
                    console.error('No valid json from insert gallery');
                }
            }
            return;
        });
    },

    /**
     * Inserts the selected galleries into the given editor
     * @param {object} e - The event object
     * @returns void
     */
    do_insert_gallery(e) {
        const ids_to_insert = this.get_field_value('insert_review_gallery_values');
        if (empty(ids_to_insert)) {
            return;
        }
        const gallery_ids = ids_to_insert.join(',');
        const target = this.get_field_value('target_editor');

        //Create the shortcode
        const shortcode = `[plek_insert_review_gallery gallery_id=${gallery_ids}]`;
        plek_main.insert_text_wp_editor(target, shortcode);
        plektemplate.remove_overlay('response_overlay');
    },

    /**
     * Changes the progressbar of the add event form
     * @param {string} line The line to modify
     * @returns void
     */
    changeAddEventProgressBar(line = '') {
        const total_inputs = jQuery('.plek-form .plek-event-form-container > div > input');
        let total_items = 0;
        let filled_items = 0;
        if (line === 'basic') {
            total_items = 3;

            //Check the fields
            if (!empty(jQuery('input#event_name').val())) {
                filled_items++;
            }
            if (jQuery('#event-venue-selection .item').length >= 1) {
                filled_items++;
            }
            if (jQuery('#event-band-selection .item').length >= 1 || jQuery('input#no_band:checked').length >= 1) {
                filled_items++;
            }
        }
        if (line === 'details') {
            total_items = 6;

            //Check the fields
            if (!empty(jQuery('input#event_poster').val())) {
                filled_items++;
            }
            if (!empty(jQuery('input#event_fb_link').val())) {
                filled_items++;
            }
            if (!empty(this.get_field_value('event_description'))) {
                filled_items++;
            }
            if (jQuery('#event-organizer-selection .item').length >= 1) {
                filled_items++;
            }
            if (!empty(jQuery('input#event_price_boxoffice').val()) || !empty(jQuery('input#event_price_presale').val())) {
                filled_items++;
            }
            if (!empty(jQuery('input#event_price_link').val())) {
                filled_items++;
            }
        }
        if (total_items === 0) {
            return;
        }
        const percentage = filled_items / total_items * 100;
        jQuery(`#add-event-progress-bar .line-${line}`).css({
            'background': `linear-gradient(to right, #D9042B ${percentage}%, #595959 ${percentage}%)`
        });

    },

    /**
     * Loads an event triggered by the infinite scroll
     * @param {object} blockContainer The container of the block to be scrolled.
     * @return {Promise} Promise that resolves with the loaded data.
     */
    async doInfiniteScroll(blockContainer) {
        var send_data = new FormData();
        send_data.append('action', 'plek_event_actions');
        send_data.append('do', 'load_block_content');

        send_data = plek_main.get_block_data(blockContainer, send_data, '');
        send_data = plek_main.get_url_query_data(send_data);
        let paged = parseInt(jQuery(blockContainer).data('paged'));
        send_data.set('paged', paged + 1);

        plek_main.activateEventInfiniteLoader(blockContainer);

        /* Hide the pagination if infinite scroll*/
        jQuery(blockContainer).find('.plek-pagination-container').hide();

        let data = await this.load_block_content(send_data);
        const allDataLoaded = (data.search('plek-event-item') <= 0) ? true : false;
        if (allDataLoaded) {
            data = `<div class="plek-add-data-loaded">${data}</div>`;
        }
        jQuery(blockContainer).parent().append(data);

        plek_main.deactivateEventInfiniteLoader(blockContainer);

        if (!allDataLoaded) {
            //Add infinite scroll again when items got returned. Otherwise it is an error or nothing more to load
            plek_main.infiniteScroll();
        }
    },

    /**
     * Sends a form with the given blockData and resolves with the first success message of the response.
     * @param {FormData} blockData The data to send.
     * @return {Promise} The promise that resolves with the first success message of the response.
     */
    async load_block_content(blockData) {
        return plek_main.send_form(blockData, false, 'load_block_content_' + blockData.get('action') + '_' + blockData.get('do'), (response) => {
            return plek_main.get_success_item_from_ajax_request(response);
        });
    },
    /**
     * Refreshes the live preview of the social media post
     * It first checks if there are any errors in the collected data
     * If there are errors, it shows them to the user using the plekerror.show_errors_from_array function
     * If there are no errors, it clears the live preview container and appends the images, text and mentions to it
     * The images are taken from the #event-sm-publisher-images-container container
     * The text and mentions are taken from the collected data
     */
    smPublisherRefreshPreview() {
        const data = this.smPublisherCollectData();
        if (!empty(data.errors)) {
            plekerror.show_errors_from_array('', data.errors, true);
            return;
        }
        jQuery('#sm-publisher-live-preview').html('');
        const images = jQuery('#event-sm-publisher-images-container').html();
        jQuery('#sm-publisher-live-preview').append('<div id="event-sm-publisher-images-container-preview">' + images + '</div>');
        jQuery('#sm-publisher-live-preview').append(data.data.text);
        jQuery('#sm-publisher-live-preview').append(data.data.mentions.join('<br/>'));
    },
    /**
     * Posts a review to the social media channels of the event.
     * @param {object} button The button that triggered this function.
     * @returns void
     */
    smPostReviewToSocialMedia(button) {
        const data = this.smPublisherCollectData();
        const event_id = this.get_field_value('event_id');
        if (!empty(data.errors)) {
            plekerror.show_errors_from_array('', data.errors, true);
            return;
        }
        const target = button.dataset.target;
        const form_data = new FormData();
        form_data.append('action', 'plek_ajax_event_form');
        form_data.append('type', 'post_review_to_sm');
        form_data.append('event_id', event_id);
        form_data.append('images', data.data.images);
        form_data.append('text', data.data.text);
        form_data.append('mentions', data.data.mentions);
        form_data.append('collaborator', data.data.collaborator);
        form_data.append('target', target);
        plek_main.send_form(form_data, button, button.id + '_' + target);
    },
    /**
     * Collects the data from the SM Publisher form and returns it in an object.
     * It also checks for errors and returns them in an array.
     * @return {Object} Object with the data and errors.
     * @property {Object} data - The collected data.
     * @property {Array} errors - The errors encountered during data collection.
     */
    smPublisherCollectData() {
        const data = {};
        const errors = [];
        data.images = [];
        data.text = '';
        data.mentions = [];
        data.collaborator = [];
        //Get the images
        if (jQuery('#event-sm-publisher-images-container .sm-publisher-image img').length > 10) {
            errors.push(__('Too many images. Please choose 10 images max.', 'plekvetica'));
        } else {
            jQuery('#event-sm-publisher-images-container .sm-publisher-image').each((index, item) => {
                data.images.push(jQuery(item).data('image-path'));
            });
        }
        //Get the text
        data.text = this.get_field_value('event_text_sm');
        //Get the mentions
        jQuery('.event-mention-item input').each((index, item) => {
            const val = jQuery(item).val();
            if (!empty(val) && jQuery(item).next('.toggle-include').attr('data-include') === 'true') {
                data.mentions.push('@' + val);
            }
            //Get the collaborator
            if (!empty(val) && jQuery(item).parent().find('.toggle-collaborator').attr('data-include') === 'true') {
                data.collaborator.push(val);
            }
        });
        //Count the characters. Throw a error, when more than 1600 characters
        if ((data.text + data.mentions.join("")).length > this.max_characters_sm_post) {
            errors.push(__('Content is too long. Please reduce to maximum %d characters.', 'plekvetica').replace('%d', this.max_characters_sm_post));
        }
        console.log(data);
        console.log(errors);
        return {
            data: data,
            errors: errors
        };
    },
    /**
     * Updates the Instagram handle of an item.
     * @param {object} item The input field containing the Instagram handle.
     * @throws {Error} If the Instagram handle is empty.
     * @returns {void} Nothing.
     */
    updateItemsInstagram(item) {
        const val = jQuery(item).val();
        if (empty(val)) {
            window.plekerror.display_info(__('Instagram handle updated', 'plekvetica'), __('Cannot update empty handle. Do delete the link, go to the band edit page and remove it there.', 'plekvetica'));
            return;
        }

        const type = jQuery(item).parent().data('type');
        const item_id = jQuery(item).parent().data('item_id');
        const handle = jQuery(item).val();
        const form_data = new FormData();
        form_data.append('action', 'plek_ajax_event_form');
        form_data.append('type', 'update_items_instagram');
        form_data.append('item-type', type);
        form_data.append('id', item_id);
        form_data.append('handle', handle);
        plek_main.send_form(form_data, false, item.id);
    },
    /**
     * Updates the character count of the social media post
     * The function first checks if the text field is empty, if so, it returns false
     * Then it gets the length of the text in the editor and the mentions
     * The total character count is then calculated and displayed in the #total_characters element
     * If the total character count is greater than the maximum allowed characters, the #total_characters element gets the class 'characters-over'
     * Otherwise, the class is removed
     */
    smPublisherUpdateCharacterCount() {
        if (empty(this.get_field_value('event_text_sm'))) {
            //This can happen when the function gets called when not on the right screen
            return false;
        }
        const count_editor = this.get_field_value('event_text_sm').length;
        const data = this.smPublisherCollectData();
        const count_mentions = data.data.mentions.join("").length;
        const total = count_editor + count_mentions;
        jQuery('#total_characters .count').text(total);

        if (total > this.max_characters_sm_post) {
            jQuery('#total_characters').addClass('characters-over');
        } else {
            jQuery('#total_characters').removeClass('characters-over');
        }
    },

    /**
     * Toggles the include attribute of the given item.
     * If the attribute is set to true, it will be set to false and vice versa.
     * @param {jQuery} item The item to toggle the include attribute for
     */
    smPublisherToggleInclude(item) {
        const current_include = jQuery(item).attr('data-include');
        if (current_include === 'true') {
            jQuery(item).attr('data-include', 'false');
        } else {
            jQuery(item).attr('data-include', 'true');
        }
    },
    /**
     * Toggles the include attribute of the given item for social media post collaborators.
     * If the attribute is set to true, it will be set to false and vice versa.
     * Checks if the maximum of 3 collaborators is reached and prevents the toggle if so.
     * @param {jQuery} item The item to toggle the include attribute for
     */
    smPublisherToggleCollaboration(item) {
        const current_include = jQuery(item).attr('data-include');
        //Check if the max is reached
        const max_collab = 3;
        if (jQuery('.toggle-collaborator[data-include="true"]').length >= max_collab && current_include === 'false') {
            alert(__('Please select no more than %d collaborators', 'plekvetica').replace('%d', max_collab));
            return;
        }
        if (current_include === 'true') {
            jQuery(item).attr('data-include', 'false');
        } else {
            jQuery(item).attr('data-include', 'true');
        }
    },

    /**
     * Checks if the mentions have been filled in.
     * If a mention is empty, it sends a request to get the Instagram handle of the band.
     * If the handle is found, it appends a div with the handle to the mention item.
     * If the handle is not found, it logs the data object to the console.
     * @returns {void} Nothing.
     */
    async smPublisherCheckMentions() {
        const mentions = jQuery('.event-mention-item input');
        for (let i = 0; i < mentions.length; i++) {
            const item = mentions[i];
            const val = jQuery(item).val();
            if (empty(val)) {
                const item_id = jQuery(item).attr('id');
                const band_name = jQuery('label[for="' + item_id + '"]').text();
                const band_id = document.querySelector("[for='"+item_id+"']").parentNode.dataset.item_id;
                form_data = new FormData;
                form_data.append('action', 'plek_webhook_actions');
                form_data.append('do', 'get_instagram_handle');
                form_data.append('name', band_name);
                form_data.append('band_id', band_id);
                form_data.append('security', plek_vars.plek_nonce);
                jQuery(item).parent().append('<div class="instagram-handle-con handle-proposal loading" data-for="' + item_id + '"></div>');
                try {
                    await plek_main.send_form(form_data, item_id, '', (response) => {
                        const data = plek_main.get_success_item_from_ajax_request(response, 'data');
                        try {
                            const data_object = JSON.parse(data);
                            if (!empty(data_object.ig_handle)) {
                                jQuery(item).parent().find('.handle-proposal').removeClass('loading');
                                jQuery(item).parent().find('.handle-proposal').append('<div class="ig_handle">' + data_object.ig_handle + '</div><div class="reason">' + data_object.reason + '</div>');
                                jQuery(item).parent().find('.instagram-handle-con').append('<button class="plek-button green accept">✅</button><button class="plek-button red reject">❎</button>');
                            } else {
                                console.log(data_object); // Should be query:"", ig_handle:"", reason:"This is the reason why it is empty"
                                jQuery(item).parent().find('.handle-proposal').append('<div class="reason">' + data_object.reason + '</div>');
                                jQuery(item).parent().find('.handle-proposal').removeClass('loading');
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }, (error_response) => {
                        jQuery(item).parent().find('.handle-proposal').removeClass('loading');
                        const error = plek_main.get_first_error_from_ajax_request(error_response);
                        jQuery(item).parent().find('.handle-proposal').append(error);
                    });
                } catch(error) {
                    console.log(error);
                }

            }
        }
    },
    /**
     * Handles the accept/reject actions of the proposal given by the Instagram Handle Proposer.
     * If the accept button is clicked, it will fill in the corresponding input field with the proposed Instagram handle.
     * If the reject button is clicked, it will simply remove the proposal container from the DOM.
     * @param {HTMLElement} button The button element that was clicked.
     */
    smPublisherProposalAction(button) {
        if (button.classList.contains('accept')) {
            const input_id = jQuery(button).parent().data('for');
            jQuery('#' + input_id).val(jQuery(button).parent().find('.ig_handle').text()).change();
        }
        jQuery(button).parent().remove();
    }

}
plekevent.construct();